import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@components/core";
import { useCurrentUser } from "@hooks/use-current-user";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import { useFormatDate } from "@hooks/use-format-date";
import ClosetItemsList from "@components/core/ClosetItemsList";
import UnlockEarlyGuide from "./UnlockEarlyGuide";
import ReturnMyClosetGuide from "./ReturnMyClosetGuide";
import CheckReturnParcelAnimation from "../CheckReturnParcelAnimation";
import ClosetPromoBannerContainer from "./ClosetPromoBannerContainer";
import ClosetShortReview from "@components/views/Closets/ClosetLayout/ClosetShortReview";

function DrawerReceivedNoNextClosetNoUnlockEarly() {
  const t = useTranslations("common");

  const user = useCurrentUser();
  const currentCloset = useCustomizableCloset();
  const formatDate = useFormatDate();

  const [partToShow, setPartToShow] = useState("defaultChoice");

  function startAnimation() {
    setPartToShow("checkReturnAnimation");
  }

  if (partToShow === "checkReturnAnimation") return <CheckReturnParcelAnimation />;
  if (partToShow === "returnMyClosetGuide")
    return <ReturnMyClosetGuide startAnimation={startAnimation} />;
  if (partToShow === "unlockEarlyGuide")
    return (
      <UnlockEarlyGuide
        close={() => setPartToShow("defaultChoice")}
        startAnimation={startAnimation}
      />
    );

  return [
    <div
      className="d-flex flex-column drawer-body"
      key="drawer-received-body"
    >
      <div className="d-flex flex-column align-items-center bg-white py-3 px-3 text-center">
        <h5 className="mb-2 px-3">{t("drawer.modal_eligibilty_guide.your_closet_is_at_home")}</h5>
        <p className="mb-0 px-3 text-gray">
          {t("drawer.modal_eligibilty_guide.you_will_be_able_to_enjoy_your_next_closet_from", {
            date: formatDate(user.next_invoice_date),
          })}
        </p>
        {currentCloset.mail_box_picking_date_requested_at && (
          <p className="px-2 text-gray mb-0">
            {t("drawer.modal_closet_received.mail_box_picking_request_done")}
          </p>
        )}

        <div className="w-100 mt-2">
          <Button
            variant="ghost-primary"
            className="mx-auto"
            onClick={() => setPartToShow("unlockEarlyGuide")}
            trackingName="drawerReceived_UnlockEarlyGuide"
          >
            {t("drawer.modal_eligibilty_guide.unlock_early")}
          </Button>
        </div>
      </div>

      <ClosetPromoBannerContainer />

      <ClosetShortReview
        closet={currentCloset}
        origin="drawer"
        className="mt-2 px-2"
      />

      <div className="mt-2 mx-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>,
    <div
      className="bg-white p-3 w-100 border-top border-light mt-2"
      key="drawer-received-footer"
    >
      <Button
        variant="primary"
        fullWidth
        onClick={() => setPartToShow("returnMyClosetGuide")}
        trackingName="drawerReceived_ReturnMyCloset"
      >
        {t("drawer.modal_eligibilty_guide.return_my_closet")}
      </Button>
    </div>,
  ];
}

export default DrawerReceivedNoNextClosetNoUnlockEarly;
